import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { z } from 'zod';
import { SegmentEntity, Segment, WithSegmentBaseEntitySchema } from '@40seas/models';
import { AiprizeCompanySearchQuery, AiprizeCompanySearchQuerySchema } from './aiprize.company.search.query';
import { AiprizeCopmanyStatus } from './aiprize.status.enum';
import { AiprizeCompanyProfileResult, AiprizeCompanyProfileResultSchema } from './aiprize.company.profile.result';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { AiprizeCompanyDecision } from './aiprize.company.decision.enum';

export const AiprizeCompanySchema = WithSegmentBaseEntitySchema(
    z.object({
        buyer: z.string(),
        searchQuery: AiprizeCompanySearchQuerySchema.nullish(),
        profileId: z.string().nullish(),
        profileResult: AiprizeCompanyProfileResultSchema.nullish(),
        status: EnumSchema(AiprizeCopmanyStatus).nullish(),
        decision: EnumSchema(AiprizeCompanyDecision).nullish(),
        match: BusinessMatchSchema.nullish(),
        lastVerificationExecutionDate: ZodDate.optional(),
        rawData: z.any().optional(),
    }),
).strict();

export class AiprizeCompany extends FromSchema(AiprizeCompanySchema) implements SegmentEntity {
    id: string;
    buyer: string;
    searchQuery?: AiprizeCompanySearchQuery;
    profileId?: string;
    profileResult?: AiprizeCompanyProfileResult;
    status: AiprizeCopmanyStatus;
    decision?: AiprizeCompanyDecision;
    match?: BusinessMatch;
    lastVerificationExecutionDate?: Date;
    rawData?: any;

    tenantId: string;
    seller: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    segments?: Segment[];
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
